'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pickBy2 = require('lodash/pickBy');

var _pickBy3 = _interopRequireDefault(_pickBy2);

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _reactRouterBootstrap = require('react-router-bootstrap');

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Nav = require('react-bootstrap/lib/Nav');

var _Nav2 = _interopRequireDefault(_Nav);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _common = require('../common');

var _AppConstants = require('../../constants/AppConstants');

var _AppConstants2 = _interopRequireDefault(_AppConstants);

var _CaseUrlBuilder = require('../../utils/CaseUrlBuilder');

var _CaseUrlBuilder2 = _interopRequireDefault(_CaseUrlBuilder);

var _FormModal = require('../../lib/mighty-fields/FormModal');

var _FormModal2 = _interopRequireDefault(_FormModal);

var _validationRules = require('../common-formsy/validationRules');

var _validationRules2 = _interopRequireDefault(_validationRules);

var _utils = require('../../utils');

var _CaseDetailHeader = require('./CaseDetailHeader');

var _CaseDetailHeader2 = _interopRequireDefault(_CaseDetailHeader);

var _CaseTabNavLink = require('./CaseTabNavLink');

var _CaseTabNavLink2 = _interopRequireDefault(_CaseTabNavLink);

var _LegalFundingLienModal = require('./LegalFundingLienModal');

var _LegalFundingLienModal2 = _interopRequireDefault(_LegalFundingLienModal);

var _PlaintiffInfoModal = require('./PlaintiffInfoModal');

var _PlaintiffInfoModal2 = _interopRequireDefault(_PlaintiffInfoModal);

var _SidebarFeed = require('./sidebar-feed/SidebarFeed');

var _SidebarFeed2 = _interopRequireDefault(_SidebarFeed);

var _TabApplications = require('./main-applications/TabApplications');

var _TabApplications2 = _interopRequireDefault(_TabApplications);

var _TabContacts = require('./main-contacts/TabContacts');

var _TabContacts2 = _interopRequireDefault(_TabContacts);

var _TabDetails = require('./main-details/TabDetails');

var _TabDetails2 = _interopRequireDefault(_TabDetails);

var _TabDocuments = require('./main-documents/TabDocuments');

var _TabDocuments2 = _interopRequireDefault(_TabDocuments);

var _TabFundings = require('./main-fundings/TabFundings');

var _TabFundings2 = _interopRequireDefault(_TabFundings);

var _TabUnderwriting = require('./main-underwriting/TabUnderwriting');

var _TabUnderwriting2 = _interopRequireDefault(_TabUnderwriting);

var _TabLawFirmPortal = require('./main-law-firm-portal/TabLawFirmPortal');

var _TabLawFirmPortal2 = _interopRequireDefault(_TabLawFirmPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var formatSocialSecurityNumber = _utils.FormattingUtils.formatSocialSecurityNumber,
    getNameOrDefault = _utils.FormattingUtils.getNameOrDefault;
var isValidSSN = _validationRules2.default.isValidSSN;
var CASE_MAIN_TABS = _AppConstants2.default.CASE_MAIN_TABS;
var Case = (_dec = (0, _mobxReact.inject)('ApplicationStore', 'CaseStore', 'FunderStore', 'LienStore', 'PlaintiffStore', 'SessionStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(Case, _Component);

  function Case() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Case);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Case.__proto__ || Object.getPrototypeOf(Case)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'applicationId', _descriptor, _this), _initDefineProp(_this, 'legalFundingLienModalAction', _descriptor2, _this), _initDefineProp(_this, 'lienId', _descriptor3, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Case, [{
    key: 'componentDidMount',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _props, FunderStore, LienStore, _case, caseId;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, FunderStore = _props.FunderStore, LienStore = _props.LienStore, _case = _props._case, caseId = _case.id;
                _context.next = 3;
                return Promise.all([FunderStore.fetchFunderTemplates(), FunderStore.fetchRepresentativesAndFunderInfo(), FunderStore.fetchSMSSavedReplies(),

                // DO NOT REMOVE: Lien information used by GuardedLogPaymentMenuItem
                LienStore.list({ caseId: caseId })]);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref2.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'onCaseApplicationChanged',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(application, data, type, load) {
        var ApplicationStore;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ApplicationStore = this.props.ApplicationStore;
                _context2.next = 3;
                return ApplicationStore.update({ application: application, data: data, load: load, type: type });

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onCaseApplicationChanged(_x, _x2, _x3, _x4) {
        return _ref3.apply(this, arguments);
      }

      return onCaseApplicationChanged;
    }()
  }, {
    key: 'onPlaintiffInfoChanged',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(plaintiffData) {
        var _props2, _case, PlaintiffStore, ssnFormatted;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _props2 = this.props, _case = _props2._case, PlaintiffStore = _props2.PlaintiffStore;
                ssnFormatted = formatSocialSecurityNumber(plaintiffData.social_security_number);


                if (ssnFormatted && isValidSSN({}, ssnFormatted)) {
                  plaintiffData.social_security_number = ssnFormatted;
                }

                _context3.next = 5;
                return PlaintiffStore.update({
                  caseId: _case.id,
                  plaintiffData: plaintiffData,
                  plaintiffId: _case.plaintiff.id
                });

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onPlaintiffInfoChanged(_x5) {
        return _ref4.apply(this, arguments);
      }

      return onPlaintiffInfoChanged;
    }()
  }, {
    key: 'onCaseLienClick',
    value: function onCaseLienClick(action, lienId, applicationId) {
      this.lienId = lienId;
      this.applicationId = applicationId;
      this.legalFundingLienModalAction = action;
      this.props.UiStore.modals.LegalFundingLien.open();
    }
  }, {
    key: 'caseUpdate',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(data) {
        var _props3, CaseStore, _case;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _props3 = this.props, CaseStore = _props3.CaseStore, _case = _props3._case;
                _context4.next = 3;
                return CaseStore.update({ caseId: _case.id, data: data });

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function caseUpdate(_x6) {
        return _ref5.apply(this, arguments);
      }

      return caseUpdate;
    }()
  }, {
    key: 'renderToolTips',
    value: function renderToolTips() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_common.PermissionRequiredToolTip, null)
      );
    }
  }, {
    key: 'renderNav',
    value: function renderNav() {
      var _props4 = this.props,
          main = _props4.main,
          pathname = _props4.pathname,
          navProps = {
        fromTab: main,
        pathname: pathname
      };


      return _react2.default.createElement(
        _Grid2.default,
        { fluid: true },
        _react2.default.createElement(
          _Nav2.default,
          { bsStyle: 'tabs', activeKey: main },
          (0, _map3.default)(this.mainTabs, function (tab, key) {
            return _react2.default.createElement(_CaseTabNavLink2.default, _extends({ key: key }, navProps, { toTab: key, label: tab.name, counts: tab.counts }));
          })
        )
      );
    }
  }, {
    key: 'renderTabDetails',
    value: function renderTabDetails() {
      return _react2.default.createElement(_TabDetails2.default, { _case: this.props._case });
    }
  }, {
    key: 'renderTabApplications',
    value: function renderTabApplications() {
      return _react2.default.createElement(_TabApplications2.default, {
        _case: this.props._case,
        onCaseApplicationChanged: this.onCaseApplicationChanged,
        onCaseLienClick: this.onCaseLienClick
      });
    }
  }, {
    key: 'renderTabFundings',
    value: function renderTabFundings() {
      return _react2.default.createElement(_TabFundings2.default, { _case: this.props._case, onLienClick: this.onCaseLienClick });
    }
  }, {
    key: 'renderTabDocuments',
    value: function renderTabDocuments() {
      return _react2.default.createElement(_TabDocuments2.default, { _case: this.props._case });
    }
  }, {
    key: 'renderTabContacts',
    value: function renderTabContacts() {
      return _react2.default.createElement(_TabContacts2.default, { _case: this.props._case, onPlaintiffInfoChanged: this.onPlaintiffInfoChanged });
    }
  }, {
    key: 'renderTabUnderwriting',
    value: function renderTabUnderwriting() {
      return _react2.default.createElement(_TabUnderwriting2.default, { _case: this.props._case });
    }
  }, {
    key: 'renderTabLawFirmPortal',
    value: function renderTabLawFirmPortal() {
      return _react2.default.createElement(_TabLawFirmPortal2.default, { _case: this.props._case });
    }
  }, {
    key: 'renderTab',
    value: function renderTab() {
      var _props5 = this.props,
          pathname = _props5.pathname,
          main = _props5.main;


      if (this.mainTabs[this.props.main]) {
        return this.mainTabs[this.props.main].render();
      }

      var newPath = new _CaseUrlBuilder2.default(pathname).change('main', 'details').toPathname();

      return _react2.default.createElement(
        'div',
        { className: 'empty' },
        _react2.default.createElement(
          'p',
          null,
          'The ',
          _react2.default.createElement(
            'b',
            null,
            this.props.main
          ),
          ' tab does not exist.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            _reactRouterBootstrap.LinkContainer,
            { to: { pathname: newPath, query: null, state: 'FROM_' + main.toUpperCase() + '_TAB' } },
            _react2.default.createElement(
              _Button2.default,
              { bsStyle: 'link' },
              _react2.default.createElement(_common.Icon, { type: 'arrow-circle-o-right' }),
              'Go to Case Details'
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          _case = _props6._case,
          aside = _props6.aside,
          pathname = _props6.pathname,
          UiStore = _props6.UiStore,
          titleName = _case && getNameOrDefault(_case.plaintiff);

      return _react2.default.createElement(
        'div',
        { className: 'case-content' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Case - ' + titleName }),
        _react2.default.createElement(_CaseDetailHeader2.default, { _case: _case }),
        _react2.default.createElement(
          _Row2.default,
          { className: 'main' },
          _react2.default.createElement(
            _Col2.default,
            { className: 'col-main', xs: 9, lg: 8 },
            this.renderNav(),
            this.renderTab()
          ),
          _react2.default.createElement(
            _Col2.default,
            { className: 'col-aside', xs: 3, lg: 4 },
            _react2.default.createElement(_SidebarFeed2.default, { _case: _case, aside: aside, pathname: pathname })
          )
        ),
        this.renderToolTips(),
        UiStore.modals.ProcessingDate.showing() && _react2.default.createElement(_FormModal2.default, {
          fieldSets: [[{ field: 'processing_follow_up_date', type: 'date' }]],
          model: _case,
          onClose: UiStore.modals.ProcessingDate.close,
          onSave: this.caseUpdate,
          title: 'Schedule Follow Up Date'
        }),
        UiStore.modals.LegalFundingLien.showing() && _react2.default.createElement(_LegalFundingLienModal2.default, {
          _case: _case,
          application: (0, _find3.default)(_case.applications, { id: this.applicationId }),
          currentAction: this.legalFundingLienModalAction,
          lienId: this.lienId
        }),
        UiStore.modals.PlaintiffInfo.showing() && _react2.default.createElement(_PlaintiffInfoModal2.default, {
          onClose: UiStore.modals.PlaintiffInfo.close,
          onSave: this.onPlaintiffInfoChanged,
          plaintiff: _case.plaintiff
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'mainTabs',
    get: function get() {
      var SessionStore = this.props.SessionStore,
          tabs = {};


      tabs[CASE_MAIN_TABS.DETAILS] = {
        isFree: true,
        name: 'Details',
        render: this.renderTabDetails
      };

      tabs[CASE_MAIN_TABS.UNDERWRITING] = {
        name: 'Underwriting',
        render: this.renderTabUnderwriting
      };

      if (this.props.FunderStore.showApplicationWorkflow) {
        tabs[CASE_MAIN_TABS.APPLICATIONS] = {
          counts: 'open_applications',
          name: 'Applications',
          render: this.renderTabApplications
        };
      }

      tabs[CASE_MAIN_TABS.FUNDINGS] = {
        counts: 'confirmed_liens',
        name: 'Liens',
        render: this.renderTabFundings
      };

      tabs[CASE_MAIN_TABS.DOCUMENTS] = {
        counts: 'case_documents',
        isFree: true,
        name: 'Documents',
        render: this.renderTabDocuments
      };

      tabs[CASE_MAIN_TABS.CONTACTS] = {
        isFree: true,
        name: 'Contacts',
        render: this.renderTabContacts
      };

      if (this.props.FunderStore.isRegistryEnabled) {
        tabs[CASE_MAIN_TABS.PORTAL] = {
          name: 'Law Firm Portal',
          render: this.renderTabLawFirmPortal
        };
      }

      if (SessionStore.isMightyFreeUser) {
        return (0, _pickBy3.default)(tabs, 'isFree');
      }

      return tabs;
    }
  }]);

  return Case;
}(_react.Component), _class3.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  ApplicationStore: _propTypes2.default.object.isRequired,
  aside: _propTypes2.default.string.isRequired,
  CaseStore: _propTypes2.default.object.isRequired,
  FunderStore: _propTypes2.default.object.isRequired,
  LienStore: _propTypes2.default.object.isRequired,
  main: _propTypes2.default.string.isRequired,
  pathname: _propTypes2.default.string.isRequired,
  PlaintiffStore: _propTypes2.default.object.isRequired,
  SessionStore: _propTypes2.default.object.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'applicationId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'legalFundingLienModalAction', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'lienId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, 'mainTabs', [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, 'mainTabs'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onCaseLienClick', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onCaseLienClick'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = Case;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(formatSocialSecurityNumber, 'formatSocialSecurityNumber', '/app/src/components/page-case/Case.js');
  reactHotLoader.register(getNameOrDefault, 'getNameOrDefault', '/app/src/components/page-case/Case.js');
  reactHotLoader.register(isValidSSN, 'isValidSSN', '/app/src/components/page-case/Case.js');
  reactHotLoader.register(CASE_MAIN_TABS, 'CASE_MAIN_TABS', '/app/src/components/page-case/Case.js');
  reactHotLoader.register(Case, 'Case', '/app/src/components/page-case/Case.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/Case.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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